import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { DSTheme } from '../../../styles/themes/types';

type PropsType = {
  icon: React.ReactNode;
  title: string;
  description: string;
  type?: 'alert' | 'complete';
  expand?: boolean;
  onClick?: () => void;
};

const useStyles = makeStyles((theme: DSTheme) => ({
  detailsSection: {
    display: 'flex',
    flexDirection: 'row',
    height: '88px',
    overflow: 'hidden',
    marginBottom: '32px',
    padding: '32px',
    borderRadius: '16px',

    backgroundColor: theme.palette.background.elevation1,
    color: theme.palette.text.primary,
    maxWidth: 'auto',

    '&.expanded': {
      height: 'auto',
    },

    [theme.breakpoints.down('sm')]: {
      maxWidth: '528px',
    },
  },

  sectionTab: {
    position: 'relative',
    maxWidth: '8px',
    minWidth: '8px',
    flexGrow: 1,
    borderRadius: '4px',
    left: '-35px',
    backgroundColor: theme.palette.grey[600],

    '&.complete': {
      backgroundColor: theme.palette.success.main,
    },

    '&.alert': {
      backgroundColor: theme.palette.error.main,
    },
  },

  sectionContent: {
    display: 'grid',
    rowGap: '32px',
    maxWidth: '592px',
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: '100%',
      maxWidth: '958px',
    },
  },

  sectionHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',

    ':first-child': {
      width: '400px',
    },
  },

  hidden: {
    display: 'none',
  },

  subtitle: {
    marginTop: '4px',
    color: theme.palette.text.navigation,
  },
}));

const DetailsSection: React.FC<PropsType> = ({
  icon,
  title,
  description,
  type = '',
  expand,
  onClick,
  children,
}) => {
  const classes = useStyles();

  return (
    <div className={`${classes.detailsSection} ${expand ? 'expanded' : ''}`}>
      <div className={`${classes.sectionTab} ${type}`} />

      <div className={classes.sectionContent}>
        <div className={classes.sectionHeader} onClick={onClick}>
          <div>
            {icon}
            <Typography variant="subtitle1">{title}</Typography>
            <Typography variant="body2" className={classes.subtitle}>
              {description}
            </Typography>
          </div>

          <div>
            <i className="material-icons">{expand ? 'expand_less' : 'expand_more'}</i>
          </div>
        </div>

        <div role="group" className={`${expand ? '' : classes.hidden}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DetailsSection;
